import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ProgramDetail } from "../program-detail/program-detail.component";
import { ProgramMaintenanceService } from "src/app/services/program-maintenance.service";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
    selector: 'one-ring-edit-detail-dialog-component',
    templateUrl: './edit-detail-dialog.component.html',
    styleUrls: ['edit-detail-dialog.component.scss']
})
export class EditDetailDialog implements OnInit {
    detailForm: FormGroup;

    constructor(
        @Inject(MAT_DIALOG_DATA) public detailData: ProgramDetail,
        private dialogRef: MatDialogRef<EditDetailDialog>,
        private programMaintenanceService: ProgramMaintenanceService,
        private spinner: NgxSpinnerService
    ) {}

    ngOnInit(): void {
        this.detailForm = new FormGroup({
            id: new FormControl({ value: this.detailData.id, disabled: true }),
            shortName: new FormControl(this.detailData.shortName),
            longName: new FormControl(this.detailData.longName),
            hours: new FormControl(this.detailData.hours),
            enableSurvey: new FormControl(this.detailData.enableSurvey),
            surveyType: new FormControl(this.detailData.surveyType),
            surveyGroup: new FormControl(this.detailData.surveyGroup),
            surveyTrigger: new FormControl(this.detailData.surveyTrigger),
            surveyIdentifier: new FormControl(this.detailData.surveyIdentifier)
        });
    }

    onSubmit(): void {
        const isEnableSurvey = this.detailForm.get('enableSurvey').value;
        if (isEnableSurvey) {
            this.detailForm.patchValue({ enableSurvey: 1 });
        } else {
            this.detailForm.patchValue({ enableSurvey: 0 });
        }

        console.log(this.detailForm.getRawValue());

        this.spinner.show(undefined, { color: '#fff' });
        this.programMaintenanceService.patchProgramDetail(this.detailForm.getRawValue())
            .subscribe({
                error: () => {
                    this.spinner.hide();
                },
                complete: () => {
                    this.spinner.hide();
                    this.closeDialog({ isChangeComplete: true });
                }
            });
    }

    closeDialog(object: Object): void {
        this.dialogRef.close(object);
    }
}